import "../../../resources/less/Family/ThemePages/SummerVacations.less";
import BaseThematique from "./BaseThematique";

class SummerVacations extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new SummerVacations();
});
